// extracted by mini-css-extract-plugin
module.exports = {"brandTrendingWrap":"yr-z"};